export default __webpack_public_path__ + "static/media/Video_camera.ab0f090e.svg";